<template>
  <div v-if="rowData[orgProp]">
    <el-popover
      ref="popover1"
      placement="top-start"
      width="330"
      trigger="hover">

      <el-row v-if="rowData[orgProp].name">

        <el-col :span="24"><b>{{rowData[orgProp].name}}</b></el-col>

        <el-col v-if="rowData[orgProp].phone" :span="6">Phone:</el-col>
        <el-col v-if="rowData[orgProp].phone" :span="18"><a :href="'tel:' + rowData[orgProp].phone">{{rowData[orgProp].phone}}</a></el-col>

        <el-col v-if="rowData[orgProp].email":span="6">e-Mail:</el-col>
        <el-col v-if="rowData[orgProp].email":span="18"><strong><a :href="emailSubject(rowData[orgProp].email)">{{rowData[orgProp].email}}</a></strong></el-col>

      </el-row>

      <el-row  v-if="rowData[personProp]" style="padding-top: 1.5rem;">

        <el-col :span="24"><i>{{personTitle}}</i>: <strong>{{rowData[personProp].name}}</strong></el-col>

        <el-col v-if="rowData[personProp].phone" :span="6">Phone:</el-col>
        <el-col v-if="rowData[personProp].phone" :span="18"><a :href="'tel:' + rowData[personProp].phone">{{rowData[personProp].phone}}</a></el-col>

        <el-col v-if="rowData[personProp].email":span="6">e-Mail:</el-col>
        <el-col v-if="rowData[personProp].email":span="18"><strong><a :href="emailSubject(rowData[personProp].email)">{{rowData[personProp].email}}</a></strong></el-col>

      </el-row>

      <el-row  v-if="rowData[contractorProp]" style="padding-top: 1.5rem;">

        <el-col :span="24"><i>{{contractorTitle}}</i>: <strong>{{rowData[contractorProp].name}}</strong></el-col>

        <el-col v-if="rowData[contractorProp].phone" :span="6">Phone:</el-col>
        <el-col v-if="rowData[contractorProp].phone" :span="18"><a :href="'tel:' + rowData[contractorProp].phone">{{rowData[contractorProp].phone}}</a></el-col>

        <el-col v-if="rowData[contractorProp].email":span="6">e-Mail:</el-col>
        <el-col v-if="rowData[contractorProp].email":span="18"><strong><a :href="emailSubject(rowData[contractorProp].email)">{{rowData[contractorProp].email}}</a></strong></el-col>

      </el-row>

</el-popover>

<el-button v-if="rowData[orgProp] || rowData.person" v-popover:popover1 :icon="icon" size="small">&nbsp;{{title}}</el-button>
</div>
<div v-else>
  &nbsp;
</div>
</template>

<script>
export default {
  name: 'contacts-popover',

  props: {
    rowData: {
      type: Object,
      required: true
    },

    title: {
      type: String,
      default: ''
    },

    icon: {
      type: String,
      default: 'fa fa-user'
    },

    orgProp: {
      type: String,
      default: 'organisation'
    },

    personTitle: {
      type: String,
      default: 'Person in Charge'
    },

    contractorTitle: {
      type: String,
      default: 'Contractor'
    },

    contractorProp: {
      type: String,
      default: 'contractor'
    },

    personProp: {
      type: String,
      default: 'person'
    }

  },

  methods: {
    emailSubject (email) {
      var msg = null

      if (this.rowData.siteName) {
        msg = '?subject=re: Site ' + this.rowData.siteName
      }

      if (this.rowData.category && this.rowData.status) {
        if (msg) {
          msg += ', issue reported [' + this.rowData.category + '] current status: ' + this.rowData.status
        } else {
          msg = 're: Issue [' + this.rowData.category + '] current status: ' + this.rowData.status
        }
      }

      return 'mailto:' + email + (msg ? msg : '')
    }
  }
}
</script>
